//
// README - Beta Component
//
// This component is marked "beta" and will go through some iterations
// before landing at a final solution. Please reach out to the Cadence team
// if you intend to use this in the meantime and we'll help you out!
//

import React from 'react';

import { RCIcon } from '../';
import {
  RCModalBase,
  RCModalBaseRootProps,
} from '../internalComponents/RCModalBase/RCModalBase';
import { RCModalActionsProps } from '../internalComponents/RCModalBase/RCModalBaseActions';
import { RCIconProps } from '../RCIcon/RCIcon';

interface RCNoticeProps {
  /** Can be used to control the state of the modal when paired with `onOpenChange`. */
  isOpen?: RCModalBaseRootProps['isOpen'];
  /** Can be used to control the state of the modal when paired with `isOpen`.
   *  Alternatively, can be used as a callback to track state changes.
  */
  onOpenChange?: RCModalBaseRootProps['onOpenChange'];
  /** The title of the notice. */
  title: string;
  /** Optionally display an icon next to the notice's content. */
  icon?: RCIconProps['icon'];
  /** Actions to be appended at the end of the modal. */
  actions?: RCModalActionsProps;
}

export function RCNotice({
  isOpen = undefined,
  onOpenChange = undefined,
  title,
  icon = undefined,
  actions = undefined,
  children = undefined,
}: React.PropsWithChildren<RCNoticeProps>) {
  return (
    <RCModalBase.Root
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      useDismissProps={{
        enabled: false,
      }}
      isModal={false}
    >
      <RCModalBase.Content
        className="rc-notice"
        position="bottom"
      >
        <div className="rc-notice__main">
          {icon &&
            <div className="rc-notice__icon">
              <RCIcon icon={icon} />
            </div>
          }
          <div className="rc-notice__text">
            <RCModalBase.Heading className="rc-notice__title">
              {title}
            </RCModalBase.Heading>
            <RCModalBase.Description className="rc-notice__description">
              {children}
            </RCModalBase.Description>
          </div>
        </div>
        {actions &&
          <div className="rc-notice__actions">
            <RCModalBase.Actions
              {...actions}
              align={actions.align ?? { desktop: 'end', mobile: 'stretch' }}
              size={actions.size ?? { mobile: 'small' }}
            />
          </div>
        }
      </RCModalBase.Content>
    </RCModalBase.Root>
  );
}
